var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 33,
    viewBox: "0 0 253 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 32,
    transform: "matrix(1 0 0 -1 0 33)",
    fill: "#DC4C4C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 32.502,
    width: 32,
    height: 3.87588,
    transform: "rotate(-90 234 32.502)",
    fill: "#DC4C4C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240.459,
    y: 32.502,
    width: 32,
    height: 1.29197,
    transform: "rotate(-90 240.459 32.502)",
    fill: "#DC4C4C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 250.795,
    y: 32.502,
    width: 32,
    height: 1.29197,
    transform: "rotate(-90 250.795 32.502)",
    fill: "#DC4C4C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 244.336,
    y: 32.502,
    width: 32,
    height: 2.58393,
    transform: "rotate(-90 244.336 32.502)",
    fill: "#DC4C4C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBg);
export default __webpack_public_path__ + "static/media/text-bg.bc602c5c710848cb9e573380cd0de093.svg";
export { ForwardRef as ReactComponent };